import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b3a09d6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3b3a09d6&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3a09d6')) {
      api.createRecord('3b3a09d6', component.options)
    } else {
      api.reload('3b3a09d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b3a09d6&", function () {
      api.rerender('3b3a09d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VSelect/index.vue"
export default component.exports